import * as React from "react";

const CertificateTrackingSVG = (props) => {
  const paths = [
    // Documento
    "M560-120H240q-33 0-56.5-23.5T160-200v-560q0-33 23.5-56.5T240-840h320l240 240v170",

    // Esquina doblada
    "M560-840v190q0 33 23.5 56.5T640-570h160",

    // Líneas interiores
    "M310-500h300",
    "M310-390h210",

    // Eslabón inferior izquierdo
    "m595-335-105 105q-54 54 0 108t108 0l105-105q54-54 0-108-21-21-48-27",

    // Eslabón superior derecho
    "m650-275 105-105q54-54 108 0t0 108L758-167q-54 54-108 0-21-21-27-48",

    // Unión central
    "m575-210 205-205",
  ];

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 -960 960 960"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {/* Borde rojo */}
      <g stroke="#E52D3D" strokeWidth={76}>
        {paths.map((path, index) => (
          <path key={`border-${index}`} d={path} />
        ))}
      </g>

      {/* Interior blanco */}
      <g stroke="#FFF" strokeWidth={42}>
        {paths.map((path, index) => (
          <path key={`inner-${index}`} d={path} />
        ))}
      </g>
    </svg>
  );
};

export default CertificateTrackingSVG;